import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer_wrap">
      <div className="footer">
        <div className="footer__copy">
          &copy; {new Date().getFullYear() || '2020'} <a href="/">REAKTIVATE</a>. All rights reserved
        </div>
        <div className="footer__creator">
          made by <a href="/">ANGLETO</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js